export const SNACKBAR_DURATION_MS = 4000;

export const SNACKBAR_VARIANTS = {
  success: "success",
  failed: "failed",
  warning: "warning",
  info: "info",
};

export const SNACKBAR_COLORS = {
  [SNACKBAR_VARIANTS.success]: "#22c55e",
  [SNACKBAR_VARIANTS.failed]: "#e53935",
  [SNACKBAR_VARIANTS.warning]: "#f59e0b",
  [SNACKBAR_VARIANTS.info]: "#2563eb",
};

const matchesAny = (text, terms) => terms.some((term) => text.includes(term));

export const getSnackbarVariant = (message) => {
  const text = String(message || "").toLowerCase();

  if (
    matchesAny(text, [
      "success",
      "successfully",
      "created",
      "updated",
      "deleted",
      "saved",
      "approved",
      "completed",
      "attached",
      "uploaded",
      "duplicated",
      "cleared",
      "changed",
      "sent",
      "downloaded",
      "checked in",
      "checked out",
    ])
  ) {
    return SNACKBAR_VARIANTS.success;
  }

  if (
    matchesAny(text, [
      "error",
      "failed",
      "fail",
      "invalid",
      "not found",
      "unauthorized",
      "auth",
      "denied",
      "unable",
      "cannot",
      "can't",
      "exception",
    ])
  ) {
    return SNACKBAR_VARIANTS.failed;
  }

  if (
    matchesAny(text, [
      "please",
      "required",
      "must",
      "select",
      "enter",
      "valid",
      "missing",
      "at least",
      "no ",
      "rejected",
      "conflict",
      "warning",
    ])
  ) {
    return SNACKBAR_VARIANTS.warning;
  }

  return SNACKBAR_VARIANTS.info;
};

export const getSnackbarColor = (message) =>
  SNACKBAR_COLORS[getSnackbarVariant(message)] || SNACKBAR_COLORS[SNACKBAR_VARIANTS.info];
